// extracted by mini-css-extract-plugin
export var item = "styles-module--item--3_koN";
export var jsAnimInit = "styles-module--jsAnimInit--1XNtr";
export var icon = "styles-module--icon--ooFhV";
export var title = "styles-module--title--1OkEz";